import React from 'react';
import { MapPin } from 'lucide-react';
export function ServiceAreas() {
  const areas = ['Phoenix', 'Scottsdale', 'Tempe', 'Mesa', 'Chandler', 'Gilbert', 'Glendale', 'Peoria', 'Surprise', 'Avondale', 'Goodyear', 'Fountain Hills'];
  return <section className="py-20 bg-[#1A1A1A] border-t border-white/5" data-id="element-217">
      <div className="container mx-auto px-4 md:px-6 text-center" data-id="element-218">
        <h2 className="text-3xl md:text-4xl font-black text-white uppercase mb-4" data-id="element-219">
          Serving All of Metro Phoenix
        </h2>
        <p className="text-white/60 mb-10 max-w-2xl mx-auto" data-id="element-220">
          We bring the detail shop to your driveway, office, or anywhere in the
          Valley. No travel fees for most locations.
        </p>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-12" data-id="element-221">
          {areas.map(area => <div key={area} className="bg-[#222] border border-white/10 px-4 py-2 rounded-full text-white/80 text-sm font-medium hover:border-[#7FD4D4] hover:text-[#7FD4D4] transition-colors cursor-default flex items-center" data-id="element-222">
              <MapPin size={12} className="mr-2 text-[#7FD4D4]" data-id="element-223" />
              {area}
            </div>)}
        </div>

        <a href="#quote" className="inline-block border-2 border-[#7FD4D4] text-[#7FD4D4] font-bold px-8 py-3 rounded-sm uppercase tracking-wide hover:bg-[#7FD4D4] hover:text-black transition-colors" data-id="element-224">
          Check Your Zip Code for Availability
        </a>
      </div>
    </section>;
}